export default keyinv => {

  return `
  <div id="UserInvited">
    <div class="Overlay"></div>
    <div class="UserForm">
      <div class="xoo-el-container xoo-el-popup-active">
        <div class="xoo-el-modal">
          <div class="xoo-el-inmodal">
            <div class="xoo-el-wrap">
              <div class="xoo-el-srcont" data-scrollbar="true" tabindex="1">
                <div class="scroll-content">
                  <div class="xoo-el-main">
                    <div class="xoo-el-form-container xoo-el-form-popup" data-active="register">
                      <div data-section="completedata" class="xoo-el-section xoo-el-active">
                        <div class="xoo-el-fields">
                          <div class="xoo-el-notice"></div>
                          <form class="xoo-el-action-form xoo-el-form-register">
                            <div class="xoo-aff-fields">
                              <div class="FormTitle">
                                Complete your data 
                              </div>
                              <div class="xoo-aff-group xoo-aff-cont-text onethird xoo-aff-cont-required xoo_el_reg_fname_cont">
                                <div class="xoo-aff-input-group">
                                  <input 
                                    type="text" 
                                    class="xoo-aff-required xoo-aff-text" 
                                    name="xoo_el_reg_fname"
                                    placeholder="First Name"
                                    required="required"
                                  />
                                </div>
                              </div>
                              <div class="xoo-aff-group xoo-aff-cont-text onethird xoo-aff-cont-required xoo_el_reg_lname_cont">
                                <div class="xoo-aff-input-group">
                                  <input 
                                    type="text" 
                                    class="xoo-aff-required xoo-aff-text" 
                                    name="xoo_el_reg_lname" 
                                    placeholder="Last Name"
                                    required="required" 
                                  />
                                </div>
                              </div>
                              <div class="xoo-aff-group xoo-aff-cont-email onethird xoo-aff-cont-required xoo_el_reg_email_cont">
                                <div class="xoo-aff-input-group">
                                  <input 
                                    type="email" 
                                    class="xoo-aff-required xoo-aff-email" 
                                    name="xoo_el_reg_email" 
                                    placeholder="Email"
                                    autocomplete="email"
                                    required="required"
                                    disabled="disabled" 
                                  />
                                </div>
                              </div>
                              <div class="xoo-aff-group xoo-aff-cont-text onethird xoo-aff-cont-required academy_register_company_cont">
                                <input 
                                  type="text" 
                                  class="xoo-aff-required xoo-aff-text" 
                                  name="academy_register_company"
                                  placeholder="Company"
                                  required="required" 
                                />
                              </div>
                              <div class="xoo-aff-group xoo-aff-cont-select_list onethird xoo-aff-cont-required academy_register_industry_cont">
                                <select 
                                  class="xoo-aff-required xoo-aff-select_list select2-hidden-accessible"
                                  name="academy_register_industry"
                                  required="required" 
                                  autocomplete="none" 
                                  data-select2-id="select2-data-1-mk3z" 
                                  tabindex="-1"
                                  aria-hidden="true"
                                >
                                </select>
                                <span 
                                  class="select2 select2-container select2-container--default" 
                                  dir="ltr"
                                  data-select2-id="select2-data-2-6fr1"
                                >
                                  <span class="selection">
                                    <span
                                      class="select2-selection select2-selection--single" 
                                      role="combobox" 
                                      aria-haspopup="true"
                                      aria-expanded="false" 
                                      tabindex="0" aria-disabled="false"
                                      aria-labelledby="select2-academy_register_industry-4l-container"
                                    >
                                    </span>
                                  </span>
                                  <span 
                                    class="dropdown-wrapper"
                                    aria-hidden="true"
                                  ></span>
                                </span>
                              </div>
                              <div class="xoo-aff-group xoo-aff-cont-country onethird xoo-aff-cont-required academy_register_country_cont">
                                <select 
                                  class="xoo-aff-required  xoo-aff-select_list select2-hidden-accessible" 
                                  name="academy_register_country"
                                  autocomplete="none" 
                                  required="required" 
                                  data-select2-id="select2-data-4-r6pq" 
                                  tabindex="-1"
                                  aria-hidden="true"
                                ></select>
                                <span 
                                  class="select2 select2-container select2-container--default" 
                                  dir="ltr"
                                  data-select2-id="select2-data-5-kqz5"
                                >
                                  <span class="selection">
                                    <span
                                      class="select2-selection select2-selection--single"
                                      role="combobox" 
                                      aria-haspopup="true"
                                      aria-expanded="false" 
                                      tabindex="0" 
                                      aria-disabled="false"
                                      aria-labelledby="select2-academy_register_country-rp-container"
                                    >                                      
                                    </span>
                                  </span>
                                  <span 
                                    class="dropdown-wrapper"
                                    aria-hidden="true"
                                  ></span>
                                </span>
                              </div>
                              <div
                                class="xoo-aff-group xoo-aff-cont-select_list onethird xoo-aff-cont-required academy_register_language_cont"
                              >
                                <select 
                                  class="xoo-aff-required xoo-aff-select_list select2-hidden-accessible"
                                  name="academy_register_language" 
                                  required="required" 
                                  data-select2-id="select2-data-7-ghxy" 
                                  tabindex="-1"
                                  aria-hidden="true"
                                ></select>
                                <span 
                                  class="select2 select2-container select2-container--default"
                                  dir="ltr"
                                  data-select2-id="select2-data-8-pf8x"
                                >
                                  <span class="selection">
                                    <span
                                      class="select2-selection select2-selection--single" 
                                      role="combobox" 
                                      aria-haspopup="true"
                                      aria-expanded="false" 
                                      tabindex="0" 
                                      aria-disabled="false"
                                      aria-labelledby="select2-academy_register_language-cj-container"
                                    >
                                    </span>
                                  </span>
                                  <span 
                                    class="dropdown-wrapper"
                                    aria-hidden="true"
                                  ></span>
                                </span>
                              </div>
                              <div class="xoo-aff-group xoo-aff-cont-password onethird xoo-aff-cont-required xoo_el_reg_pass_cont">
                                <label for="xoo_el_reg_pass" class="xoo-aff-label">
                                  Minimum 14 characters and must include 1 capital letter, 
                                  1 number, and 1 special character.
                                </label>
                                <div class="xoo-aff-input-group">
                                  <span class="xoo-aff-input-icon fas fa-key"></span>
                                  <input 
                                    type="password"
                                    class="xoo-aff-required xoo-aff-password" 
                                    name="xoo_el_reg_pass" 
                                    placeholder="Password"
                                    minlength="14" 
                                    autocomplete="new-password" 
                                    required="required"
                                  />
                                </div>
                              </div>
                              <div class="xoo-aff-group xoo-aff-cont-password onethird xoo-aff-cont-required xoo_el_reg_pass_again_cont">
                                <div class="xoo-aff-input-group">
                                  <span class="xoo-aff-input-icon fas fa-key"></span>
                                  <input 
                                    type="password"
                                    class="xoo-aff-required xoo-aff-password" 
                                    name="xoo_el_reg_pass_again" 
                                    placeholder="Confirm Password"
                                    autocomplete="new-password" 
                                    required="required"
                                  >
                                </div>
                              </div>
                              <div class="xoo-aff-group xoo-aff-cont-checkbox_single one academy_register_distributor_cont">
                                <div class="xoo-aff-checkbox_single">
                                  <label>
                                    <input 
                                      type="checkbox" 
                                      name="academy_register_distributor"
                                      class="xoo-aff-checkbox_single" 
                                      value="yes"
                                    />
                                    <span class="Enhaced">I am a Distributor</span>
                                  </label>
                                </div>
                              </div>
                              
                              <div class="xoo-aff-group xoo-aff-cont-textarea one academy_conditions_info_a_cont">
                                <textarea 
                                  class="AcademyConditionsInfoA xoo-aff-textarea" 
                                  name="academy_conditions_info_a" 
                                  placeholder="" 
                                  disabled="disabled"
                                  rows="2"></textarea>
                              </div>

                              <div class="xoo-aff-group xoo-aff-cont-checkbox_single one academy_register_newsletter_cont">
                                <div class="AcademyRegisterNewsletter xoo-aff-checkbox_single">
                                  <label>
                                    <input 
                                      type="checkbox" 
                                      name="academy_register_newsletter" 
                                      class="AcademyRegisterNewsletter xoo-aff-checkbox_single" 
                                      value="yes"
                                    />
                                    Subscription to newsletter
                                  </label>
                                </div>
                              </div>

                              <div class="xoo-aff-group xoo-aff-cont-checkbox_single one academy_register_mailpartners_cont">
                                <div class="AcademyRegisterMailpartners xoo-aff-checkbox_single">
                                  <label>
                                    <input 
                                      type="checkbox" 
                                      name="academy_register_mailpartners" 
                                      class="AcademyRegisterMailpartners xoo-aff-checkbox_single" 
                                      value="yes"
                                    />
                                    Partners mails
                                  </label>
                                </div>
                              </div>

                              <div class="xoo-aff-group xoo-aff-cont-textarea one academy_conditions_info_b_cont">
                                <textarea 
                                  class="AcademyConditionsInfoB xoo-aff-textarea" 
                                  name="academy_conditions_info_b" 
                                  placeholder="" 
                                  rows="2"
                                  disabled="disabled"
                                ></textarea>
                              </div>

                            </div>
                            <button 
                              type="submit" 
                              class="button btn xoo-el-action-btn xoo-el-register-btn"
                            >
                              Update data
                            </button>
                            <input type="hidden" name="_xoo_el_form" value="update">
                            <input type="hidden" name="xoo_el_redirect" value="/">
                            ${ keyinv ? '<input type="hidden" name="keyinv" value="' + keyinv + '">' : '' }
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="Close">
        <img src="${ window.academystatus.themebase }/assets/icons/close.png" />
      </div>
    </div>
  </div>
  `
}